import React, { useCallback } from 'react';
import { BulkOpsAnalyticsProvider } from '@atlassian/jira-bulk-operations-analytics/src/controllers/index.tsx';
import { useReferenceLoader } from '@atlassian/jira-bulk-operations-common/src/utils/reference-loader/use-reference-loader/index.tsx';
import { useQuickstartPillVisibilityStore } from '@atlassian/jira-quickstart-pill-visibility/src/controllers/index.tsx';
import { useBulkSelectionStore } from '../../../controllers/bulk-selection/bulk-selection-store/index.tsx';
import { useBulkChangePermission } from '../../../controllers/use-bulk-permission/index.tsx';
import { BulkOperationsLoader } from './bulk-edit-loader/index.tsx';
import { BulkEditSidebar } from './bulk-edit-sidebar/index.tsx';

const BulkEdit = () => {
	const bulkChangePermission = useBulkChangePermission();

	const bulkOperationsForm = useReferenceLoader();

	const [, { toggleBulkEditSidebar }] = useBulkSelectionStore();
	const [, { toggleShowQuickstart }] = useQuickstartPillVisibilityStore();
	const onOpenSidebar = useCallback(() => {
		toggleBulkEditSidebar({ showBulkEditSidebar: true });
	}, [toggleBulkEditSidebar]);

	const onCloseSidebar = useCallback(() => {
		toggleBulkEditSidebar({ showBulkEditSidebar: false });
		toggleShowQuickstart({ showQuickstartPill: true });
	}, [toggleBulkEditSidebar, toggleShowQuickstart]);

	if (!bulkChangePermission) {
		return null;
	}

	return (
		<BulkOpsAnalyticsProvider>
			<BulkEditSidebar bulkOperationsForm={bulkOperationsForm} />
			<BulkOperationsLoader
				bulkOperationsForm={bulkOperationsForm}
				onCloseSidebar={onCloseSidebar}
				onOpenSidebar={onOpenSidebar}
			/>
		</BulkOpsAnalyticsProvider>
	);
};

export default BulkEdit;
